import type { Guide } from "#public"

import { GuidePressed } from "../controller/GuideVisible"
import { ToggleButton } from "./ToggleButton"

export function GuideToggles({
  guides,
  hidden,
  on_toggle,
}: {
  guides: Guide[]
  hidden: string[]
  on_toggle: (id: string) => void
}) {
  return (
    <>
      {guides.map(g => (
        <ToggleButton
          key={g.id}
          name={g.name}
          onPressedChange={() => on_toggle(g.id)}
          pressed={GuidePressed(g, hidden)}
        />
      ))}
    </>
  )
}
